import Button from '@C/Button';
import { router, usePage } from '@inertiajs/react';
import React from 'react';
const NotificationAlertBox = () => {
    const { notifications = [], hideNotificationAlert = false } = usePage().props;
    if (!notifications.length || hideNotificationAlert)
        return React.createElement(React.Fragment, null);
    const unreadCount = notifications.filter(n => !n.read_at).length;
    if (!unreadCount)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "col-span-1 w-full text-center alert rounded-lg shadow-lg py-3 px-5 leading-6 alert-info mb-3" },
        React.createElement("div", { className: "alert-warning" },
            React.createElement("strong", null,
                "You have ",
                unreadCount,
                " unread notification(s)")),
        React.createElement("div", { className: "flex justify-center mt-2" },
            React.createElement(Button, { onClick: () => {
                    router.get(route('contact.index'));
                } }, "View in Communications"))));
};
export default NotificationAlertBox;
